import type { ExtractPropTypes, PropType } from 'vue'
import { makeStringProp } from '../../utils'

export const npButtonProps = {
  /**
   * 类型定义
   */
  type: makeStringProp(''),

  class: makeStringProp(''),
  click: {
    type: Function as PropType<
      ((e?: MouseEvent) => void) | ((e?: MouseEvent) => Promise<void>)
    >,
  },
}

export type NpButtonProps = ExtractPropTypes<typeof npButtonProps>
